<script>
    // core components
    import ImpuestoPlantilla from "../../viewsERP/ImpuestoPlantilla.svelte";
  </script>
  
  <div class="flex flex-wrap mt-4">
    <div class="w-full mb-12 px-4">
      <ImpuestoPlantilla />
    </div>
  </div>